/**
 * this file contains all redux-saga watchers & workers for the transaction
 * - watchers watch for dispatched actions
 * - workers invoke another actions in response to the processed actions
 *
 * NOTE: Saga's use the new ES6 generator functions function* ()
 * NOTE: Arrow-function can not be used as generators as the yield keyword
 * may not work in an arrow function's body
 *
 * Created by Tom on 19/06/18
 */

import { takeEvery, call, put } from 'redux-saga/effects'
import moment from 'moment'

import C from '../constants'
import config from '../config'
import { request, isEmpty, substitute } from '../utility/utilities'

// import action creators
import * as InvestmentActions from '../actions/investmentActions'

/* -----------------------------------------------------------------------------
    WATCHER & WORKER SAGA TO FETCH THE LIST OF Investment
----------------------------------------------------------------------------- */

// watcher saga for fetching the investment data
export function* watchFetchInvestment() {
    yield takeEvery(C.FETCH_INVESTMENT_DATA, workerFetchInvestment)
}

// worker saga for fetching the investmentn data
function* workerFetchInvestment() {

    // set the headers
    const headers = {
        method: 'GET',
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        mode: 'cors', // NOTE: make sure Mulesoft endpoint allows CORS !!!!!!
        cache: 'default'
    }

    // set the endpoint
    const todayDate = moment().format("YYYY-MM-DD"),
          requestURL = substitute(config.endpoints.investmentFetchURL, {todayDate:todayDate});

    try {
        // show the loader
        yield put(InvestmentActions.showInvestmentLoader(true))

        // get the response promise object
        const response = yield call(request, requestURL, headers)

        //added additional check if there is data and value is 0 show no data avaliable
        if(!isEmpty(response.data) && response.data.data.portfolio_asset_positions[0].overall_value > 0 ) {

            // get the array of transaction objects
            const bankAccountDetails = response.data.data.portfolio_asset_positions

            // set the transaction list
            yield put(InvestmentActions.setInvestmentData(
                bankAccountDetails[0].asset_class_detail_list
            ))

            // set the success flag to true
            yield put(InvestmentActions.setInvestmentFetchSuccess(true))
        }

    } catch (error) {

        // set the success flag to false
        yield put(InvestmentActions.setInvestmentFetchSuccess(false))

    } finally {

        // hide the loader regardless
        yield put(InvestmentActions.showInvestmentLoader(false))
    }
}



// WEBPACK FOOTER //
// ./src/sagas/investmentSaga.js